module.exports = __webpack_public_path__ + "img/14.0a3fe66e.jpg";